export type Sort = {
  id: string;
  desc: boolean;
};

export function serializeSort(sort: Sort[]): string {
  return sort.map((s) => `${s.id} ${s.desc ? 'desc' : 'asc'}`).join(',');
}
